module.exports = __webpack_public_path__ + "static/media/016 I GUERRA M_Casa del mutilato.4d6aa28f.svg";